import { MonitorOff } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog.tsx";
import { useLogoutOtherDevices } from "./useLogoutOtherDevices.ts";

/**
 * Settings → Account: the "log out other devices" control, with the confirm
 * step that names its consequence. It is the option CASA 2.2.2 asks for after
 * a credential change we never hear about, such as a Google or Microsoft
 * password change. The call itself is {@link useLogoutOtherDevices}.
 */
export const LogoutOtherDevices = () => {
  const [open, setOpen] = useState(false);
  const mutation = useLogoutOtherDevices();

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setOpen(true)}
        data-statsig-name="settings-account-logout-other-devices"
        className="gap-1.5! shrink-0"
      >
        <MonitorOff className="size-4" strokeWidth={2.5} />
        Log out other devices
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Log out other devices?</DialogTitle>
            <DialogDescription>
              Every other device logged in to your account will be logged out, and any MCP clients
              connected to it will be disconnected until you connect them again. You stay logged in
              here.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="flex-row justify-end">
            <Button
              variant="outline"
              onClick={() => setOpen(false)}
              data-statsig-name="settings-account-logout-other-devices-cancel"
            >
              Cancel
            </Button>
            <Button
              variant="default"
              onClick={() => mutation.mutate(undefined, { onSuccess: () => setOpen(false) })}
              disabled={mutation.isPending}
              data-statsig-name="settings-account-logout-other-devices-confirm"
            >
              {mutation.isPending ? "Logging out..." : "Log out other devices"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
